import httpHelper from "../helpers/http_helper";

const joinRequestService = {
    async list(data) {
        return await httpHelper.post("/RestApi/Service/JoinRequests", data);
    },
    async deleteRequests(ids) {
        return await httpHelper.post("/RestApi/Service/DeleteJoinRequest", {
            joinRequestIds: JSON.stringify(ids)
        });
    },
    async approveRequests(ids) {
        return await httpHelper.post("/RestApi/Service/ApproveNotificationJIRequest032020", {
            idsRequest: JSON.stringify(ids)
        });
    },
    async getRequest(idNotify, idRequest) {
        return await httpHelper.post("/RestApi/Service/NotificationJIRequest", {
            idNotify,
            idRequest
        });
    },
    async approveJIRequests(idNotify, idRequest) {
        return await httpHelper.post("/RestApi/Service/ApproveNotificationJIRequest", {
            idNotify,
            idRequest
        });
    }
}

export default joinRequestService;